import { getCurrentEnvironment } from '@telstra-connect/config/config';
import { flagIsSet } from '@telstra-connect/feature-flags';
import { IFeatureFlags } from './common';
import flagsData from './flags';
import { ApplicationName } from '@telstra-connect/order-tracker/activity-tracking';

let featureFlags: IFeatureFlags;

export const loadFeatureFlags = (): void => {
    const environment = getCurrentEnvironment();

    // tslint:disable-next-line
    const flags = global['applications'] && global['applications'][ApplicationName] || {};
    // the step to check for flags is implemented statically to have typescript/intellisense support
    featureFlags = Object.freeze({
        application: flagIsSet(flagsData.application, environment),
        orderListSearch: flags.orderListSearch || false,
        orderExpress: flags.orderExpress || false,
        orderEnquiry: flags.orderEnquiry || false,
        advanceDownload: flags.advanceDownload || false,
        orderTrackerInt: flags.orderTrackerInt || false,
        orderTrackerDetailInt: flags.orderTrackerDetailInt || false,
        orderTrackerUpdateBanner: flags.orderTrackerUpdateBanner || false,
        orderDetailDeliveryAddress: flags.orderDetailDeliveryAddress || false,
        orderInfoTip: flags.orderInfoTip || false,
        ponrFooterFlag: flags.ponrFooterFlag || false,
        showRequestNumber: flags.showRequestNumber || false,
        orderDetailCustomerAcceptanceInt: flags.orderDetailCustomerAcceptanceInt || false,
        visible: flags.visible || false,
        fullListPage: flags.fullListPage || false,
        upcomingAppointmentFlag: flags.upcomingAppointmentFlag || false,
        orderListColumnChanges: flags.orderListColumnChanges || false,
        displayRamboProductCategory: flags.displayRamboProductCategory || false,
        yourReferenceInt: flags.yourReferenceInt || false,
        orderListReferenceInt: flags.orderListReferenceInt || true,
        legacyOrderDetailsSubStageStatus: flags.legacyOrderDetailsSubStageStatus || false,
        hideDatefieldNoDataFromDownstream: flags.hideDatefieldNoDataFromDownstream || false,
        tedig3296UpliftedOrderDetails: flags.tedig3296UpliftedOrderDetails || flagsData.tedig3296UpliftedOrderDetails[environment],
        tedig3007OrderListChanges: flags.tedig3007OrderListChanges || flagsData.tedig3007OrderListChanges[environment],
        orderTrackerIntUIUpliftment: flags.orderTrackerIntUIUpliftment || flagsData.orderTrackerIntUIUpliftment[environment],
        orderTrackerDetailsIntUIUpliftment: flags.orderTrackerDetailsIntUIUpliftment || flagsData.orderTrackerDetailsIntUIUpliftment[environment],
        tedig3007OrderListPart2: flags.tedig3007OrderListPart2 || flagsData.tedig3007OrderListPart2[environment],
        tedig3007OrderListExportButton: flags.tedig3007OrderListExportButton || false,
        tedig4307Dynamic5g: flags.tedig4307Dynamic5g || flagsData.tedig4307Dynamic5g[environment],
        disablePdfDownloadInt: flags.disablePdfDownloadInt || flagsData.disablePdfDownloadInt[environment]
    });
};

export const getFlags = (): IFeatureFlags => {
    return featureFlags;
};
